
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryProductsDialog extends Serenity.EntityDialog<EnquiryProductsRow, any> {
        protected getFormKey() { return EnquiryProductsForm.formKey; }
        protected getIdProperty() { return EnquiryProductsRow.idProperty; }
        protected getLocalTextPrefix() { return EnquiryProductsRow.localTextPrefix; }
        protected getService() { return EnquiryProductsService.baseUrl; }
        protected getDeletePermission() { return EnquiryProductsRow.deletePermission; }
        protected getInsertPermission() { return EnquiryProductsRow.insertPermission; }
        protected getUpdatePermission() { return EnquiryProductsRow.updatePermission; }

        protected form = new EnquiryProductsForm(this.idPrefix);

    }
}